import { render, staticRenderFns } from "./AmbulatorKart.vue?vue&type=template&id=2e9d2354"
import script from "./AmbulatorKart.vue?vue&type=script&lang=js"
export * from "./AmbulatorKart.vue?vue&type=script&lang=js"
import style0 from "./AmbulatorKart.vue?vue&type=style&index=0&id=2e9d2354&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports